module.exports = __webpack_public_path__ + "img/not-found.a828d7fd.png";